const baseUri = 'products';

export default {

  index(query, limit, cancelToken) {
    return api.get(baseUri, {
      params: {
        query,
        limit,
      },
      cancelToken,
    });
  },

  show(id) {
    return api.get(`${baseUri}/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/product.js